module.exports = __webpack_public_path__ + "img/1-2.2b3a6e3b.png";